import React from "react";
import SignupIMG from "../../assets/Images/AboutUs/SignupIMG.jpg"; 
import "./../../theme/css/LoadingScreen.css"; 

const LoadingScreen = () => (
  <div className="loading-container">
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-circle"></div>
        <div className="loading-text">Connessione in corso...</div>
      </div>
    </div>
  </div>
);

export default LoadingScreen;
